module.exports = __webpack_public_path__ + "static/media/certificate-icon-3.2811dfe4.png";